<template>
  <div class="body v2-list-page">
    <div class="order-page-container">
      <p class="print-only reports-page__print-title">Relatórios: {{ title }}</p>

      <TabPurchases v-if="report === 'compras'" :title="title" />
      <TabOrders v-else-if="report === 'ordens'" :title="title" />
      <TabWhatsapp v-else-if="report === 'whatsapp'" :title="title" />
      <TabPriceVariation
        v-else-if="report === 'preco'"
        :key="request_id || 'periodo'"
        :title="title"
        :cotacaoInput="request_id"
      />
    </div>
  </div>
</template>

<script>
import TabPurchases from "./tabs/TabPurchases.vue";
import TabPriceVariation from "./tabs/TabPriceVariation.vue";
import TabOrders from "./tabs/TabOrders.vue";
import TabWhatsapp from "./tabs/TabWhatsapp.vue";

/** Títulos de cada página do submenu Relatórios (rotas em routes.js). */
const TITLES = {
  compras: "Compras",
  ordens: "Ordem de compras",
  whatsapp: "WhatsApp",
  preco: "Análise de Preço por Cotação",
};

export default {
  props: {
    report: { type: String, default: "compras" },
    request_id: { type: Number },
  },
  components: {
    TabPurchases,
    TabPriceVariation,
    TabOrders,
    TabWhatsapp,
  },
  computed: {
    title() {
      return TITLES[this.report] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_list-page-v2";
.print-only {
  display: none;
}
.reports-page__print-title {
  font-weight: 600;
  font-size: 1.4rem;
}
@media print {
  .print-only {
    display: block;
  }
  .order-page-container {
    background: #fff;
  }
  @page {
    margin: 3%;
  }
}
</style>
